import { ApolloProvider } from "@apollo/client";
import { datadogLogs } from "@datadog/browser-logs";
import { APIProvider } from "@vis.gl/react-google-maps";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import client from "@lib/apollo";

const DOMAIN = {
  ko: "https://thisisneverthat.com/",
  en: "https://intl.thisisneverthat.com/",
  jp: "https://thisisneverthat.jp/",
};

const PREVIEW_DOMAIN = {
  ko: "https://d257kvs4acsh7t.cloudfront.net/",
  en: "https://dgklsgs33ap3q.cloudfront.net/",
  jp: "https://d2pzid5ybp4he6.cloudfront.net/",
};

const lang = localStorage.getItem("i18nextLng");
let newLang = "ko";

// localhost일 때
// 로컬스토리지의 i18nextLng를 쓰거나
// 없으면 기본값(ko)를 넣어줌

// localhost 아닐 때
// url을 보고 매치되는 언어를 찾아서
// 로컬스토리지의 i18nextLng에 넣어줌

if (window.location.href.includes("localhost") || window.location.hostname.includes("ngrok")) {
  newLang = lang ? lang : newLang;
} else {
  if (window.location.href.includes(DOMAIN.ko) || window.location.href.includes(PREVIEW_DOMAIN.ko)) {
    newLang = "ko";
  }

  if (window.location.href.includes(DOMAIN.en) || window.location.href.includes(PREVIEW_DOMAIN.en)) {
    newLang = "en";
  }

  if (window.location.href.includes(DOMAIN.jp) || window.location.href.includes(PREVIEW_DOMAIN.jp)) {
    newLang = "jp";
  }
}

localStorage.setItem("i18nextLng", newLang || "");

// PROD 환경일 때 만 로깅
if (
  window.location.href.includes(DOMAIN.ko) ||
  window.location.href.includes(DOMAIN.en) ||
  window.location.href.includes(DOMAIN.jp)
) {
  let datadogService = "thisisneverthat JP";
  if (window.location.href.includes(DOMAIN.ko)) datadogService = "thisisneverthat KR";
  else if (window.location.href.includes(DOMAIN.en)) datadogService = "thisisneverthat INTL";

  // Datadog 로그 초기화
  datadogLogs.init({
    clientToken: import.meta.env.VITE_REACT_DATA_DOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: datadogService,
    env: "prod",
    forwardErrorsToLogs: true, // 에러 자동 로깅
    // TODO: CheckoutIntl 데이터독 로그 추가 후 forwardConsoleLogs 주석 또는 제거
    forwardConsoleLogs: "all",
    sessionSampleRate: 100, // 로그 샘플링 비율
    version: "v1.0.0",
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <APIProvider apiKey={import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY}>
      <ApolloProvider client={client}>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: false,
          }}
        >
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </APIProvider>
  </HelmetProvider>,
);
